//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ReportInputItem } from './ReportInputItem';
import { ReportType } from './Enums';

export class LendingLibraryItemListReportInputItem extends ReportInputItem {
    LendingLibraryItemIDs: string[] = [];
    override readonly Type: ReportType = ReportType.LendingLibrary;

    constructor(initializer?: Partial<Omit<LendingLibraryItemListReportInputItem, "Type">>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static override readonly ClassName: string = "LendingLibraryItemListReportInputItem";
}
